/**
 * 이사 유형 코드의 표시 라벨. 정의는 공유 패키지에 있다 — 프리뷰의 유형 카드와
 * 앱의 리뷰 화면이 같은 이름을 쓰게 하려는 것이다.
 */

export {
  MOVING_TYPE_CODE_FALLBACK_LABELS,
  formatMovingTypeSelectedTypesForDisplay,
} from '@miso/counsel-schema';
